import { Injectable, OnDestroy } from '@angular/core';
import { TitleStrategy } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, take, takeUntil } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomTitleStrategyService extends TitleStrategy implements OnDestroy {
  $destroy = new Subject<void>();
  currentTitle: string | null = null;
  baseTitle = 'BizLab Analytics - Flow';

  constructor(private title: Title, private translate: TranslateService) {
    super();

    this.translate.onLangChange.pipe(takeUntil(this.$destroy)).subscribe(() => {
      this.setTranslatedTitle(this.currentTitle);
    });
  }

  override updateTitle(routerSnapshot: RouterStateSnapshot) {
    this.currentTitle = this.buildTitle(routerSnapshot);
    this.setTranslatedTitle(this.currentTitle);
  }

  private setTranslatedTitle(titleKey: string) {
    if (!this.currentTitle) {
      this.title.setTitle(this.baseTitle);
      return;
    }

    const translationKey = `routes.${titleKey}`;

    this.translate
      .get(translationKey)
      .pipe(take(1))
      .subscribe((title: string) => {
        const translatedTitle = this.baseTitle + ' | ' + title;
        this.title.setTitle(translatedTitle);
      });
  }

  ngOnDestroy() {
    this.$destroy.next();
    this.$destroy.complete();
  }
}
